import { render, staticRenderFns } from "./AddCustomer.template.vue?vue&type=template&id=a9bfbfb8&scoped=true&"
var script = {}
import style0 from "./AddCustomer.template.vue?vue&type=style&index=0&id=a9bfbfb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bfbfb8",
  null
  
)

export default component.exports